import React, { useEffect, useRef } from "react";
import { DealerResultsProps } from "./types";
import { StatusIndicator } from "./StatusIndicator";
import { LoadingBar } from "@/components/animations";

export function DealerResults({ loading, error, visibleDealers, highlightIndex, onHighlightChange, onSelect }: DealerResultsProps) {
    const containerRef = useRef<HTMLDivElement>(null);
    const itemRefs = useRef<Array<HTMLDivElement | null>>([]);

    useEffect(() => {
        if (highlightIndex < 0) return;
        const el = itemRefs.current[highlightIndex];
        if (!el) return;
        el.scrollIntoView({ block: "nearest" });
    }, [highlightIndex]);

    return (
        <div ref={containerRef} className="relative rounded w-full max-h-[200px] overflow-y-auto" role="listbox" id="dealer-listbox" aria-label="Dealer results">
            <div className="flex flex-col justify-center w-full h-full">
                <div className="flex flex-col gap-1.5 items-start justify-center w-full">
                    {loading && <div className="flex items-center justify-center w-full h-full min-h-[25px]"><LoadingBar /></div>}
                    {!loading && !error && visibleDealers.length === 0 && <div className="px-2.5 py-1.5 text-sm text-menu-hover w-full text-center">No dealers found</div>}
                    {!loading &&
                        !error &&
                        visibleDealers.map((dealer, idx) => (
                            <div
                                key={dealer.id}
                                ref={(node) => {
                                    itemRefs.current[idx] = node;
                                }}
                                onClick={() => onSelect(dealer)}
                                onMouseEnter={() => onHighlightChange(idx)}
                                role="option"
                                aria-selected={highlightIndex === idx}
                                className={`flex items-center gap-2 px-2.5 py-1.5 w-full cursor-pointer hover:bg-gray-50 rounded transition-colors ${
                                    highlightIndex === idx ? "bg-gray-50" : ""
                                }`}
                            >
                                <StatusIndicator status={dealer.budgetStatus} />
                                <p className="font-inter font-normal text-title-color text-sm">{dealer.dealerName}</p>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
}
